function Hero() {
  return (
    <section className="hero">
      <p className="hero-eyebrow">Estudiante</p>
      <h1>Hola, soy Jhorell<span className="hero-dot">.</span></h1>
      <p>Estudiante de Ciencia de la Computación — apasionado por el desarrollo web y la programación.</p>
    </section>
  );
}

export default Hero;
